// TODO: bad naming of the file/component
import { ReactElement } from 'react';
import { Row, Col, Menu, Layout } from 'antd';
import Overview from './tabs/overview/Overview';
import loading from '../../assets/loading.svg';
import { useHistory, useParams } from 'react-router-dom';
import { Notification } from '../../interfaces/backend/Notifications';
import Playground from './Playground';
import { User } from '../../interfaces/api/Auth';
import { Environments } from '../../api/environments/interface';
import TemplatesListContainer from './tabs/TemplatesListContainer';
import Sider from 'antd/es/layout/Sider';
import { Content } from 'antd/es/layout/layout';
import Production from './production/Production';
import Parameters from './parameters/Parameters';
import { AccountSummary } from '../../App';

interface Props {
  updateNotification: (notification: Notification) => void;
  notification: Notification;
  user: User;
  environment: Environments;
  tabId: string;
  accountSummary: AccountSummary;
}

const NotificationTabs = (props: Props): ReactElement => {
  const { tabId } = useParams<{ tabId: string }>();

  const history = useHistory();
  const changeTab = (key: string): void => {
    history.push(
      `/${props.notification.envId}/notifications/${props.notification.notificationId}/notificationConfig/${key}`
    );
  };

  const renderTabContent = (pane: string): ReactElement => {
    let tabContent;
    switch (pane) {
      case 'parameters':
        tabContent = <Parameters notification={props.notification} />;
        break;
      case 'overview':
        tabContent = (
          <Overview
            notification={props.notification}
            updateNotification={props.updateNotification}
          />
        );
        break;
      case 'production':
        tabContent = (
          <Production
            notification={props.notification}
            updateNotification={props.updateNotification}
          />
        );
        break;
      case 'design':
        tabContent = (
          <TemplatesListContainer notification={props.notification} />
        );
        break;
      case 'integrate':
        tabContent = (
          <Playground
            notification={props.notification}
            environment={props.environment}
            user={props.user}
          />
        );
        break;
      default:
        return <div>Error in tab manager</div>;
    }

    return (
      <Row>
        <Col
          span={24}
          style={{
            padding: '7px 24px 24px 24px'
          }}
        >
          {tabContent}
        </Col>
      </Row>
    );
  };

  return (
    <div>
      {props.notification ? (
        <>
          <Layout hasSider style={{ position: 'relative' }}>
            <Sider
              theme="light"
              style={{
                overflow: 'auto',
                minHeight: '100vh'
              }}
            >
              <Menu
                mode="inline"
                defaultSelectedKeys={[tabId]}
                style={{ height: '100%', borderRight: 0, paddingTop: 8 }}
                items={[
                  {
                    key: 'overview',
                    label: '1. Configure',
                    onClick: () => changeTab('overview')
                  },
                  {
                    key: 'design',
                    label: '2. Design',
                    onClick: () => changeTab('design')
                  },
                  {
                    key: 'integrate',
                    label: '3. Send',
                    onClick: () => changeTab('integrate')
                  },
                  {
                    key: 'parameters',
                    label: '4. Review Parameters',
                    onClick: () => changeTab('parameters'),
                    disabled: !props.accountSummary?.hasUsers
                  },
                  {
                    key: 'production',
                    label: '5. Production',
                    onClick: () => changeTab('production'),
                    disabled: !props.accountSummary?.hasUsers
                  }
                ]}
              />
            </Sider>
            <Content style={{ padding: '16px 0 0 0' }}>
              {renderTabContent(tabId)}
            </Content>
          </Layout>
        </>
      ) : (
        <div className="spinner">
          <img src={loading} alt="Loading" />
        </div>
      )}
    </div>
  );
};
export default NotificationTabs;
